import { resolveKeyPress } from './keyboardHandlers/resolvekeypress';
import { setSegmentMarkers } from './segmentHandlers/setSegmentMarkers';
import { convertFragmentToSegment } from './segmentHandlers/convertFragmentToSegment';
import * as DRMHandlers from './drmHandlers/drmhandlers';
import { setupAccessibilityAttributes } from './a11y/setup';
import { getLocalStorage, setLocalStorage, setValuesBasedOnLocalStorage } from './localStorageHandlers/localStorageHandlers';
import { getAVType } from './avTypeHandlers/getAVType';
import { handlePreRolls } from './advertHandlers/handlePreRolls';
import { handleVerticalVideoControls } from './verticalVideoHandlers/handleVerticalVideoControls';
import { setupNicamKijkwijzerIcons, showNicamAfterUiDelay } from './nicamHandlers/nicamhandler';
export class NpoPlayerServices {
    getAVType(avType) {
        return getAVType(avType);
    }
    keyboardHandler(playerContext, e) {
        resolveKeyPress(playerContext, e);
    }
    convertFragmentToSegment(fragment) {
        return convertFragmentToSegment(fragment);
    }
    segmentMarkersHandler(segment, title) {
        return setSegmentMarkers(segment, title);
    }
    decideProfile(playerContext, preferredDRM = '') {
        return DRMHandlers.decideProfile(playerContext, preferredDRM);
    }
    verifyDRM(playerContext, payload) {
        return DRMHandlers.verifyDRM(playerContext, payload);
    }
    setStoredUserPrefs(key, value) {
        return setLocalStorage(key, value);
    }
    getStoredUserPrefs() {
        return getLocalStorage();
    }
    handleUserPrefs(playerContext) {
        if (playerContext === undefined) {
            console.error('playerContext is undefined');
            return;
        }
        return setValuesBasedOnLocalStorage(playerContext);
    }
    setAccessibilityAttributes(playerContext) {
        if (playerContext === undefined) {
            console.error('playerContext is undefined');
            return;
        }
        return setupAccessibilityAttributes(playerContext);
    }
    async schedulePreRolls(playerContext) {
        await handlePreRolls(playerContext);
    }
    handleVerticalVideoControls(playerContext, variant) {
        return handleVerticalVideoControls(playerContext, variant);
    }
    showNicamAfterUiDelay(playerContext, uiManager) {
        return showNicamAfterUiDelay(playerContext, uiManager);
    }
    setupNicamKijkwijzerIcons(playerContext) {
        return setupNicamKijkwijzerIcons(playerContext);
    }
}
